import React from "react";
import News from "../News";

function NewsPage() {
  return (
    <div>
      <News />
    </div>
  );
}

export default NewsPage;
